import moment from 'js-utils/moment';
import gettext from 'js-utils/gettext';
import ngettext from 'js-utils/ngettext';
import {formatMajorMoney} from 'js-utils/intl';

import {simpleStringHash} from 'js-utils/string';
import {
    FREE_FLAG_TEXT,
    MOMENT_DATE_AND_TIME_FORMAT_STRING,
    MOMENT_DATE_FORMAT_STRING,
    FALLBACK_IMAGE_LIST,
} from './constants';

/*
@param {string} startDate - YYYY-MM-DD formatted date string
@param {string} startTime - HH:MM:SS formatted time string
@param {number} instanceCount - Number of upcoming repeating event instances
*/
export const getEventTimeString = (startDate, startTime, instanceCount) => {
    let dateString = moment(startDate).format(MOMENT_DATE_FORMAT_STRING);

    if (startTime) {
        dateString = moment(`${startDate} ${startTime}`).format(MOMENT_DATE_AND_TIME_FORMAT_STRING);
    }

    if (instanceCount) {
        //Translators: Sun, Dec 12th + more events
        //Translators: Sun, Dec 12th, 7:00pm + 10 more events
        //Translators: Sun, Dec 12th, 4:00 + 4 more events
        dateString = ngettext(
            '%(dateString)s + %(instanceCount)s more event',
            '%(dateString)s + %(instanceCount)s more events',
            instanceCount === 1,
            {dateString, instanceCount}
        );
    }

    return dateString;
};

/*
@param {object} minPrice - Object containing the data for properly formatting price string
@param {bool} isFree - Flag which sets if the event is a free event or not
*/
export const getPriceInfo = (minPrice = {}, isFree) => {
    const {
        minPriceValue,
        currency,
        currencyFormat,
    } = minPrice;

    let priceString;

    if (minPriceValue <= 0 && !isFree) {
        return priceString;
    }

    if (minPriceValue && currency) {
        const formattedMoney = formatMajorMoney(minPriceValue, currency, currencyFormat);

        priceString = gettext('Starts at %(valueString)s', {valueString: formattedMoney});
    }

    if (isFree) {
        priceString = FREE_FLAG_TEXT;
    }

    return priceString;
};

/*
@param {string} id - Event ID
Returns a random fallback image randomized on the given events ID
*/
export const getRandomFallbackImage = (id = `random ${Math.random()}`) => (FALLBACK_IMAGE_LIST[simpleStringHash(id) % FALLBACK_IMAGE_LIST.length]);

/*
@param {string} minPrice - Object containing the data for properly formatting price string
@param {bool} isFree - Flag which sets if the event is a free event or not
@param {string} ticketsBy - The source of the ticket
*/
export const getFormattedPriceString = (minPrice, isFree, ticketsBy) => {
    const priceString = getPriceInfo(minPrice, isFree);

    let formattedPriceString;

    let formattedTicketsByString;

    if (priceString) {
        formattedPriceString = priceString;

        if (ticketsBy && ticketsBy !== 'Eventbrite') {
            formattedTicketsByString = gettext('on %(ticketsBy)s', {ticketsBy});
        }
    } else if (ticketsBy && ticketsBy !== 'Eventbrite') {
        formattedTicketsByString = gettext('On %(ticketsBy)s', {ticketsBy});
    }

    if (priceString && formattedTicketsByString) {
        formattedPriceString = gettext('%(priceString)s • %(formattedTicketsByString)s', {priceString, formattedTicketsByString});
    }

    if (!priceString && formattedTicketsByString) {
        formattedPriceString = formattedTicketsByString;
    }

    return formattedPriceString;
};
